import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* listsWatchers() {
  yield all([
    takeEvery(EntryActionTypes.LIST_IN_CURRENT_BOARD_CREATE, ({ payload: { data } }) =>
      services.createListInCurrentBoard(data),
    ),
    takeEvery(EntryActionTypes.LIST_CREATE_HANDLE, ({ payload: { list } }) =>
      services.handleListCreate(list),
    ),
    takeEvery(EntryActionTypes.LIST_UPDATE, ({ payload: { id, data } }) =>
      services.updateList(id, data),
    ),
    takeEvery(EntryActionTypes.LIST_UPDATE_HANDLE, ({ payload: { list, included } }) =>
      services.handleListUpdate(list, included),
    ),
    takeEvery(EntryActionTypes.LIST_MOVE, ({ payload: { id, index } }) =>
      services.moveList(id, index),
    ),
    takeEvery(EntryActionTypes.LIST_TRANSFER_PREPARE, ({ payload: { id, boardId } }) =>
      services.prepareTransferList(id, boardId),
    ),
    takeEvery(
      EntryActionTypes.LIST_TRANSFER,
      ({ payload: { id, boardId, index, addUserIds, pointSystemOptions } }) =>
        services.transferList(id, boardId, index, addUserIds, pointSystemOptions),
    ),
    takeEvery(EntryActionTypes.LIST_TRANSFER_POINT_SYSTEM_CONFIRM, ({ payload: { enable } }) =>
      services.confirmListTransferPointSystem(enable),
    ),
    takeEvery(
      EntryActionTypes.LIST_CLONE,
      ({ payload: { id, boardId, navigateAfterClone, addUserIds } }) =>
        services.cloneList(id, boardId, navigateAfterClone, addUserIds),
    ),
    takeEvery(EntryActionTypes.LIST_DELETE, ({ payload: { id } }) => services.deleteList(id)),
    takeEvery(EntryActionTypes.LIST_DELETE_HANDLE, ({ payload: { list } }) =>
      services.handleListDelete(list),
    ),
    takeEvery(EntryActionTypes.LIST_ARCHIVE, ({ payload: { id } }) => services.archiveList(id)),
    takeEvery(EntryActionTypes.LIST_ARCHIVE_HANDLE, ({ payload: { list } }) =>
      services.handleListArchive(list),
    ),
    takeEvery(EntryActionTypes.LIST_RESTORE, ({ payload: { id } }) => services.restoreList(id)),
    takeEvery(EntryActionTypes.LIST_RESTORE_HANDLE, ({ payload: { list } }) =>
      services.handleListRestore(list),
    ),
  ]);
}
